// extracted by mini-css-extract-plugin
export default {"font-renta":"EditDevicePage_font-renta__R4K9k","buttonContainer":"EditDevicePage_buttonContainer__2NBz1"};